export default __webpack_public_path__ + "static/media/team4.d4d20c5f.png";